import React, { memo, useState } from "react";
import styles from "./SearchResultItem.module.scss";
import { Appliance } from "../../../../../../model/appliance";
import { ApplianceItem } from "../../../../../../model/solar-recommendation-form/appliance-item";
import { CombinedAppliance } from "../../../../../../model/combined-appliance-category";

type AddingProps = {
	isSelected: boolean;
	onAddAppliance: (appliance: Appliance) => void;
	onRemoveAppliance: (appliance: Appliance) => void;
};

type EditingProps = {
	appliance: ApplianceItem;
	onEditAppliance: (appliance: ApplianceItem) => void;
};

type Props = {
	category: CombinedAppliance;
	isAdded: boolean;
	addingProps?: AddingProps;
	editingProps?: EditingProps;
	selectedAppliances?: Appliance[];
	previouslySelectedAppliances: Appliance[];
};

const SearchResultCategoryItem: React.FC<Props> = memo((props: Props) => {
	const { category, addingProps, editingProps, selectedAppliances = [], isAdded, previouslySelectedAppliances } = props;
	const [isExpanded, setIsExpanded] = useState(false);

	const toggleExpand = () => {
		setIsExpanded(!isExpanded);
	};

	const categoryData = category.toApplianceCategory();
	const appliances = categoryData.appliances || [];

	const isApplianceSelected = (appliance: Appliance) => {
		return selectedAppliances.some(selected => selected.id === appliance.id);
	};

	const isAppliancePreviouslySelected = (appliance: Appliance) => {
		return previouslySelectedAppliances.some(selected => selected.id === appliance.id);
	};

	const hasSelectedAppliances = appliances.some(appliance => isApplianceSelected(appliance) || isAppliancePreviouslySelected(appliance));

	const handleCheckboxChange = (appliance: Appliance, e: React.ChangeEvent<HTMLInputElement>) => {
		e.stopPropagation();

		if (addingProps) {
            if (e.target.checked) {
                // Only add if not previously selected
                if (!isAppliancePreviouslySelected(appliance)) {
                    addingProps.onAddAppliance(appliance);
                }
            } else {
                // Only remove if it was newly selected
                if (!isAppliancePreviouslySelected(appliance)) {
                    addingProps.onRemoveAppliance(appliance);
                }
            }
        }
		// handleCategoryButton()
	};

	return (
		<div className={styles.searchResultCategory}>
			{/* Category Header */}
			<div className={`${styles.searchResultItem}`} onClick={toggleExpand}>
				<div className={styles.searchResultItemInfo}>
					<div className={styles.division}>
						<img src={categoryData.imageUrl} alt={categoryData.name} />
						<span>{categoryData.name}</span>
						<span className={styles.applianceCount}>({appliances.length})</span>
					</div>
					<button className={`standardButton ${styles.button} ${hasSelectedAppliances || isAdded ? styles.removeButton : ""}`} onClick={toggleExpand}>
						{isAdded  ? "Added" : hasSelectedAppliances ? "Remove" : "Add"}
					</button>
				</div>
			</div>

			{/* Appliances List with Checkboxes */}
			{isExpanded && (
				<div className={styles.appliancesList}>
				<div className={styles.header}>Select Appliance</div>
					{appliances.map((appliance, index) => {
						const isChecked = isApplianceSelected(appliance) || isAppliancePreviouslySelected(appliance);
						return (
							<div key={index} className={`${styles.searchResultItem} ${styles.appliance}`}>
								<div className={styles.searchResultItemInfo}>
									<label className={styles.checkboxContainer}>
										<input type="checkbox" checked={isChecked} onChange={e => handleCheckboxChange(appliance, e)} className={styles.checkbox} />
										<span className={styles.checkboxCustom}></span>
										<span className={styles.applianceName}>{appliance.name}</span>
									</label>
									{editingProps && (
										<button
											className={`standardButton ${styles.button}`}
											onClick={() => {
												editingProps.onEditAppliance({
													...editingProps.appliance,
													editingProps: {
														...editingProps.appliance.editingProps,
														editing: true,
														newAppliance: appliance,
													},
												});
											}}
										>
											Change
										</button>
									)}
								</div>
							</div>
						);
					})}
					<div style={{ paddingRight: 10, paddingLeft: 10 }}>
						<button onClick={toggleExpand} className={styles.applianceListButton}>
							Save
						</button>
					</div>
				</div>
			)}
		</div>
	);
});

export default SearchResultCategoryItem;
